import { AnchorType } from "shared/types/NavigationAnchor"

export function getAnchor(type: AnchorType) {
  return localStorage.getItem(`navigation-anchor-${type}`)
}
export function setAnchor(type: AnchorType, path: string) {
  localStorage.setItem(`navigation-anchor-${type}`, path)
}
